//@prepros-prepend fakeAJAX.js
//@prepros-prepend wnumb/wNumb.js

import 'babel-polyfill';
import jwt_decode from "jwt-decode";

window.helpers = {};

// hash

window.helpers.hash = {
    gethash: function() {
        var $hash = window.location.hash;
        if ($hash.length) return $hash;
        else return '';
    },
    gethashnoext: function() {
        var $hash = window.location.hash;
        if ($hash.length) return $hash.replace('#','');
        else return '';
    },
    sethash: function(hashdata) {
        if (hashdata && hashdata.length) {
            window.location.hash = hashdata;
        }
    }
};

// fontsize

window.helpers.fontsize = {
    get: function () {
        return (parseFloat($('body').css('font-size'))).toFixed(3);
    },
    set: function () {
        // $('body').css('font-size', '');
        // var $fsize = this.get();
        // // var $new_fsize = parseInt($fsize) + parseInt(parseInt(($fsize - parseInt($fsize)) * 1000) / 125) * .125;
        // var $new_fsize = ;
        // $('body').css('font-size', $new_fsize);
    }
};

// window offsets

window.helpers.pos = {
    offset: {
        top: function () {
            return window.pageYOffset || document.documentElement.scrollTop;
        },
        bottom: function () {
            var top = $window.offset.top();
            return document.documentElement.clientHeight + top;
        },
        right: function () {
            return document.documentElement.clientWidth;
        }
    },
    width: function () {
        return document.documentElement.clientWidth;
    },
    height: function () {
        return document.documentElement.clientHeight;
    }
};

// img to bg

export function imgtobg($imgbox) {
    if ($imgbox && $imgbox.length) {
        // $imgbox.trigger('reset');
        setsrc($imgbox);
        return false;
    }

    var imgbox = $('.js-imgbox');
    if (!imgbox || !imgbox.length) return false;

    function setsrc($imgbox) {
        if ($imgbox && $imgbox.length) {
            imgbox = $imgbox;
        }
        imgbox.each(function() {
            var $imgbox = $(this);
            var $img = $imgbox.find('img.js-img');
            if ($img && $img.length) {
                var $src = $img.eq(0).attr('src');
                $imgbox.css({
                    'background-image': 'url('+$src+')'
                });
                $img.fadeOut(100).addClass('img-hidden');
            }
        });
    }

    setsrc();

    imgbox.on('reset', function() {
        setsrc($(this));
    });
}

export function daysOfYear(year)
{
    return isLeapYear(year) ? 366 : 365;
}

export function isLeapYear(year) {
    return year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0);
}

export function getCurrentDayOfYear() {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 0);
    const diff = (now - start) + ((start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000);
    const oneDay = 1000 * 60 * 60 * 24;
    return Math.floor(diff / oneDay);
}

export function getPercent(smallerNumber, biggerNumber) {
    return smallerNumber * 100 / biggerNumber;
}

export function getDateFromString(dateString) {
    let fullDateArr = dateString.split(' ');
    if (!fullDateArr.length) return null;
    let dateArr = fullDateArr[0].split('-');
    let timeArr = fullDateArr[1] ? fullDateArr[1].split(':') : [0, 0, 0];
    let d = +dateArr[2];
    let m = +dateArr[1] - 1;
    let y = +dateArr[0];
    let hours = timeArr[0] || 0;
    let mins = timeArr[1] || 0;
    let secs = timeArr[2] || 0;
    return new Date(y, m, d, hours, mins, secs);
}
export function formatDate(date) {
    if (!date) return null;
    date = new Date(new Date(date).setHours(0,0,0,0));

    return `${formatZeroNum(date.getDate())}.${formatZeroNum(date.getMonth()+1)}.${date.getFullYear()}`;
}
export function formatZeroNum(num) {
    if (num === undefined || num === null) return false;
    return num < 10 ? '0'+num : ''+num;
}

export function clearTokenInfo() {
    localStorage.removeItem('token');
    localStorage.removeItem('expiresAt');
}

export function setAccessToken(token) {
    const {exp} = jwt_decode(token);
    localStorage.setItem('token', token);
    localStorage.setItem('expiresAt', exp);
}

export function checkExpiredToken() {
    if (!localStorage.getItem('expiresAt')) {
        return null;
    }
    return (Math.floor(Date.now() / 1000) > localStorage.getItem('expiresAt'));
}

export function formatN (n) {
  var nn = n.toExponential(2).split(/e/);
  var u = Math.floor(+nn[1] / 3);
  return Math.round(nn[0] * Math.pow(10, +nn[1] - u * 3));
}

export function formatNLabel (n) {
  var nn = (+n).toExponential(2).split(/e/);
  var u = Math.floor(+nn[1] / 3);
  return ['p', 'n', 'u', 'm', '', 'тыс', 'млн', 'млрд', 'T'][u+4];
}

export function formatNumObj(num, objects) {
  let cases = [ 2, 0, 1, 1, 1, 2 ];
  return objects[ (num % 100 > 4 && num % 100 < 20) ? 2 : cases[ Math.min(num % 10, 5) ] ];
}

// wait for event

// export let waitForFinalEvent = (function () {
//     let timers = {};
//     return function (callback, ms, uniqueId) {
//         if (!uniqueId) { uniqueId = "Don't call this twice without a uniqueId"; }
//         if (timers[uniqueId]) { clearTimeout (timers[uniqueId]); }
//         timers[uniqueId] = setTimeout(callback, ms);
//     };
// })();

export function thumborImageUrl(image, type = undefined) {
    if (!type) {
      return 'image/' + image;
    }
    return 'image/' + type + '/' + image;
}

export function thumborRetinaImageUrl(type, retinaType, image) {
  if (window.devicePixelRatio === 1) {
    return thumborImageUrl(image, type);
  } else {
    return thumborImageUrl(image, retinaType);
  }
}

export function getDotCenterParams($dot) {
  const dotParams = $dot.getBoundingClientRect();
  const {left, top, width, height} = dotParams;
  return {x: left + width / 2, y: top + height / 2};
}

export function getDistanceBetweenDots(dot1, dot2) {
  return Math.hypot(dot1.x - dot2.x, dot1.y - dot2.y);
}

export function getCenterBetweenDots(dot1, dot2) {
  return {x: (dot1.x + dot2.x) / 2, y: (dot1.y + dot2.y) / 2};
}

export function getDeltaBetweenDots(dot1, dot2, mult) {
 return {x: (dot1.x - dot2.x) * (mult - 1), y: (dot1.y - dot2.y) * (mult - 1)};
}

export function setViewport() {
  const viewheight = window.innerHeight;
  const viewwidth = window.innerWidth;
  const viewport = document.querySelector("meta[name=viewport]");
  viewport.setAttribute("content", "height=" + viewheight + "px, width=" + viewwidth + "px, initial-scale=1.0");
}




// WEBPACK FOOTER //
// ./resources/assets/js/src/helpers.js